import type { Map } from 'immutable';

import type DonationMatchingRule from 'entities/donationMatchingRule/model';

import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';

export const addAction = (donationMatchingRule: DonationMatchingRule) => ({
  type: ADD,
  donationMatchingRule,
});

export const addMultipleAction = (donationMatchingRules: Map<string, DonationMatchingRule>) => ({
  type: ADD_MULTIPLE,
  donationMatchingRules,
});

export const updateAction = (donationMatchingRule: DonationMatchingRule) => ({
  type: UPDATE,
  donationMatchingRule,
});

export const removeAction = (id: string) => ({
  type: REMOVE,
  id,
});
